var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-dialog", {
    attrs: {
      title: _vm.$gettext("Aufgabe löschen"),
      question: _vm.$gettext("Möchten Sie die Aufgabe wirklich löschen?"),
      height: "200",
    },
    on: {
      close: _vm.onClose,
      confirm: _vm.onConfirm,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }